(function () {
  'use strict';
  if (window.SanoHomeReviews) return;
  var selector = '[data-sano-home-reviews]', instances = new Map();
  function initialize(section) {
    if (instances.has(section)) return;
    var rail = section.querySelector('[data-review-rail]');
    var originals = rail ? Array.from(rail.querySelectorAll('[data-review-card]')) : [];
    if (originals.length < 2) return;
    rail.scrollLeft = 0;
    var lifecycle = new AbortController(), motion = matchMedia('(prefers-reduced-motion: reduce)');
    var track = document.createElement('div'); track.className = 'sano-home-reviews__track';
    originals.forEach(function (card) { track.appendChild(card); }); rail.appendChild(track);
    var clones = originals.map(function (card) {
      var clone = card.cloneNode(true); clone.dataset.reviewClone = 'true';
      clone.removeAttribute('data-review-index'); clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach(function (node) { node.removeAttribute('id'); });
      clone.querySelectorAll('button,a,input,select,textarea,[tabindex]').forEach(function (node) { node.tabIndex = -1; });
      track.appendChild(clone); return clone;
    });
    var animation = null, cycle = 0, duration = 0, step = 0, visible = false, manual = false, timer = 0, destroyed = false;
    function on(node, type, fn, options) { node.addEventListener(type, fn, Object.assign({signal:lifecycle.signal}, options || {})); }
    function phase() { return animation && duration ? (Number(animation.currentTime) || 0) % duration / duration : 0; }
    function playback() {
      if (!animation) return;
      if (visible && !document.hidden && !motion.matches && !manual) animation.play(); else animation.pause();
      section.classList.toggle('is-review-visible', visible && !document.hidden);
    }
    function measure() {
      if (destroyed) return;
      var position = phase(), width = rail.clientWidth;
      var mobile = matchMedia('(max-width:749px)').matches, gap = mobile ? 12 : 16;
      var cardWidth = mobile ? Math.min(innerWidth * .56, 225) : (width - 68) / 5;
      track.style.setProperty('--review-card-width', cardWidth + 'px');
      step = cardWidth + gap;
      var lastCard = originals[originals.length - 1].getBoundingClientRect();
      cycle = lastCard.right - originals[0].getBoundingClientRect().left + gap;
      duration = cycle / 54 * 1000;
      if (animation) animation.cancel();
      animation = track.animate([{transform:'translate3d(0,0,0)'},{transform:'translate3d(' + -cycle + 'px,0,0)'}],{duration:duration,iterations:Infinity,easing:'linear'});
      animation.pause(); animation.currentTime = position * duration;
      rail.classList.add('is-compositor-ready');
      // Read all text geometry before changing any toggle visibility.
      var toggleStates = originals.concat(clones).map(function (card) {
        var body = card.querySelector('[data-review-body]'), toggle = card.querySelector('[data-review-toggle]');
        return body && toggle ? {node:toggle,hidden:!card.classList.contains('is-expanded') && body.scrollHeight <= body.clientHeight + 2} : null;
      });
      toggleStates.forEach(function (state) { if (state) state.node.hidden = state.hidden; });
      playback();
    }
    function enterManual() {
      clearTimeout(timer);
      if (manual) return;
      var offset = phase() * cycle; manual = true; animation.pause();
      track.classList.add('is-manual'); rail.scrollLeft = offset;
    }
    function resume() {
      clearTimeout(timer);
      if (!manual || motion.matches || rail.contains(document.activeElement)) return;
      var offset = ((rail.scrollLeft % cycle) + cycle) % cycle;
      rail.scrollLeft = 0; animation.currentTime = offset / cycle * duration;
      track.classList.remove('is-manual'); manual = false; playback();
    }
    function deferResume() { clearTimeout(timer); timer = setTimeout(resume, 900); }
    function navigate(direction) {
      enterManual(); var target = rail.scrollLeft + direction * step;
      if (target < 0) { rail.scrollLeft += cycle; target += cycle; }
      rail.scrollTo({left:target,behavior:motion.matches?'instant':'smooth'}); deferResume();
    }
    on(rail,'pointerdown',enterManual,{passive:true});
    on(window,'pointerup',function () { if (manual) deferResume(); },{passive:true});
    on(window,'pointercancel',function () { if (manual) deferResume(); },{passive:true});
    on(rail,'wheel',function (event) { if (Math.abs(event.deltaX)>Math.abs(event.deltaY)) { enterManual(); deferResume(); } },{passive:true});
    on(rail,'keydown',function(event){ if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();navigate(event.key==='ArrowRight'?1:-1);} });
    on(rail,'focusin',enterManual); on(rail,'focusout',deferResume);
    on(track,'click',function(event){
      var toggle=event.target.closest('[data-review-toggle]');if(!toggle)return;
      enterManual();var card=toggle.closest('[data-review-card]'),expanded=card.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded',String(expanded));toggle.textContent=expanded?'Lees minder':'Lees meer';
      if(!expanded)deferResume();
    });
    var prev=section.querySelector('[data-review-prev]'),next=section.querySelector('[data-review-next]');
    if(prev)on(prev,'click',function(){navigate(-1);});if(next)on(next,'click',function(){navigate(1);});
    function updateMotion() { if(motion.matches)enterManual();else resume();playback(); }
    on(motion,'change',updateMotion); on(document,'visibilitychange',playback);
    var visibility=new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;playback();},{threshold:0});visibility.observe(section);
    // Stop decorative star motion for cards outside the scrolling viewport.
    var cards=new IntersectionObserver(function(entries){entries.forEach(function(entry){entry.target.classList.toggle('is-review-card-visible',entry.isIntersecting);});},{root:rail,threshold:0});
    originals.concat(clones).forEach(function(card){cards.observe(card);});
    var measureFrame=0;
    function scheduleMeasure(){if(!destroyed&&!measureFrame)measureFrame=requestAnimationFrame(function(){measureFrame=0;measure();});}
    var resize=new ResizeObserver(scheduleMeasure);resize.observe(rail);
    measure();updateMotion();if(document.fonts)document.fonts.ready.then(scheduleMeasure);
    section.dataset.reviewAutoplayReady='true';
    var destroy=function(){destroyed=true;clearTimeout(timer);cancelAnimationFrame(measureFrame);lifecycle.abort();animation.cancel();visibility.disconnect();cards.disconnect();resize.disconnect();clones.forEach(function(card){card.remove();});originals.forEach(function(card){rail.appendChild(card);card.classList.remove('is-review-card-visible');});track.remove();rail.classList.remove('is-compositor-ready');section.classList.remove('is-review-visible');delete section.dataset.reviewAutoplayReady;instances.delete(section);};
    section._sanoReviewsDestroy=destroy;instances.set(section,destroy);
  }
  function scan(root){if(root.matches&&root.matches(selector))initialize(root);root.querySelectorAll(selector).forEach(initialize);}
  window.SanoHomeReviews={scan:scan};scan(document);
  document.addEventListener('shopify:section:load',function(event){scan(event.target);});
  document.addEventListener('shopify:section:unload',function(event){instances.forEach(function(destroy,section){if(event.target===section||event.target.contains(section))destroy();});});
  window.addEventListener('pagehide',function(){instances.forEach(function(destroy){destroy();});});
  window.addEventListener('pageshow',function(event){if(event.persisted)scan(document);});
}());

